import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogStack: [],
    currentProject: {}
  },
  mutations: {
    dialogStackPush: function(state, item) {
      state.dialogStack.push(item)
    },
    resetDialogStack: function(state, newStack) {
      state.dialogStack = newStack
    },
    setCurrentProject: function(state, item) {
      state.currentProject = item
    }
  },
  actions: {

  }
})
